import React, { ReactNode } from 'react';

import { TNodeCardTypeValue } from '../interfaces';

import styles from '../LimenetProfile.module.scss';

const TechnologyCard = <T, >({
	card,
	nodeType,
}: {
	card: T;
	nodeType: Record<string, TNodeCardTypeValue<T>>;
}) => {
	return card ? (
		<div className={styles.crowdCellInfo}>
			<div className={styles.technologyCardRow}>
				<div className={styles.crowdCellInfoItem}>
					{nodeType.plmn.title}:&nbsp;<span>{card?.[nodeType.plmn.name] as ReactNode}</span>
				</div>
				<div className={styles.crowdCellInfoItem}>
					{nodeType.name.title}:&nbsp;<span>{card?.[nodeType.name.name] as ReactNode}</span>
				</div>
			</div>
			<div className={styles.technologyCardRow}>
				<div className={styles.crowdCellInfoItem}>
					{nodeType.id.title}:&nbsp;<span>{card?.[nodeType.id.name] as ReactNode}</span>
				</div>
				<div className={styles.crowdCellInfoItem}>
					{nodeType.idBits.title}:&nbsp;<span>{card?.[nodeType.idBits.name] as ReactNode}</span>
				</div>
			</div>
		</div>
	) : <></>;
};

export default TechnologyCard;
